module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Users_Icon.f4973156.png";